<template>
  <div>
    <v-card>
      <v-card-title class="headline">Please Pick User</v-card-title>
      <v-card-text v-if="contactsToPick.length">
        <v-layout row wrap>
          <v-flex xs12 sm6 pl-1 v-for="contact in contactsToPick" :key="contact.id">
            <v-btn
              block
              color="primary"
              @click.prevent="onContactPicked(contact)"
            >{{ contact.name }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text v-if="!contactsToPick.length">
        <v-layout row wrap>
          <v-flex xs12 pl-1 warning--text>
            No contact found, Please fill the form manually.
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn color="green darken-1" flat="flat" @click.native="resetUser">Reset</v-btn> -->
        <v-btn color="green darken-1" flat="flat" @click.native="onCloseContactPicker">Close</v-btn>
      </v-card-actions>
    </v-card>
    <!-- {{contactsToPick}} -->
  </div>
</template>
<<script>
import { mapActions } from 'vuex'

export default {
  props: ['facilityId'],
  data: () => ({
      contactsToPick: []
  }),
  methods: {
      ...mapActions('customerSearch', [
          'getFacilityDataById'
      ]),
      onContactPicked (contact) {
          console.log('picked')
          this.$emit('onContactPicked', contact)
      },
      onCloseContactPicker () {
          this.$emit('onCloseContactPicker')
      },
      async retrieveContactsForPick() {
          // the facility contacts is in facility data
          var facilityData = await this.getFacilityDataById({id: this.facilityId})
          this.contactsToPick = facilityData.contacts
      }
  },
  watch: {
      'facilityId' : async function() {
          if (this.facilityId == null || this.facilityId.length == 0) {
              console.log('not need load user in user picker')
          } else {
              console.log('will load contact for facility: ' + this.facilityId)
              await this.retrieveContactsForPick()
          }
      }

  },
  async mounted () {
  }

}
</script>
